<template>
  <div>
    <form>
      <!-- ///responsável -->
      <div class="">
        <div :class="!data.id ? 'row col-md-10 no-padding' : 'row col-md-12 no-padding'">

          <div class="col-md-3" v-if="data.id">
            <form-group-image :url="url + 'car/measure/image/' + data.id" :value="data.imageURL" img-type="square" />
          </div>

          <div class="col-md-5">
            <fg-select :options="measureList" v-model="data.MeasureId" :selected="data.MeasureId" label="Tipo Medida" />
          </div>

          <div class="col-md-4">
            <fg-select :options="categoryList" v-model="data.CategoryId" :selected="data.CategoryId"
              label="Categoria" />
          </div>

          <div class="col-md-2">
            <fg-select :options="isCeilingList" v-model="data.isCeiling" :selected="data.isCeiling"
              label="Medida do Teto?" />
          </div>

          <div class="col-md-3">
            <fg-input class="clean" type="text" label="Medida" placeholder="Medida" v-model="data.Measures"
              v-bind:readonly="readonly" />
          </div>
          <div class="col-md-2">
            <fg-input class="clean" type="number" label="Número Rachaduras" placeholder="Número Rachaduras"
              v-model="data.Cracks" v-bind:readonly="readonly" />
          </div>
          <div class="col-md-2">
            <fg-select :options="isShafts" v-model="data.isShafts" :selected="data.isShafts" label="É eixo" />
          </div>
          <!-- <div class="col-md-3">
            <fg-input class="clean" type="text" label="Altura Direita" placeholder="Altura Direita (m)"
              v-model="data.HeightRightSide" v-bind:readonly="readonly" />
          </div>

          <div class="col-md-3">
            <fg-input class="clean" type="text" label="Altura Esquerda" placeholder="Altura Esquerda (m)"
              v-model="data.HeightLeftSide" v-bind:readonly="readonly" />
          </div>

          <div class="col-md-3">
            <fg-input class="clean" type="text" label="Maior largura" placeholder="Maior largura (m)"
              v-model="data.GreaterWidth" v-bind:readonly="readonly" />
          </div>

          <div class="col-md-3">
            <fg-input class="clean" type="text" label="Menor largura" placeholder="Menor largura (m)"
              v-model="data.SmallestWidth" v-bind:readonly="readonly" />
          </div> -->
          <div :class="data.id ? 'col-md-10 no-padding' : 'col-md-5'">

            <div class="col-md-10">
              <fg-input class="clean" type="text" label="Outros Defeitos" placeholder="descreva os defeitos, caso haja"
                v-model="data.OtherDefects" v-bind:readonly="readonly" />
            </div>
          </div>

          <!-- <div class="col-md-4">
          <fg-input
            class="clean"
            type="text"
            label="Valor"
            placeholder="Valor"
            v-on:input="format"
            v-model="data.formattedMarkValueCentavos"
            v-bind:readonly="readonly"

          />
        </div> -->


        </div>
      </div>
    </form>


  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import moment from 'moment';
import formGroupImage from 'src/components/UIComponents/Inputs/formGroupImage.vue';
import { NAMES } from "../../../config"

export default {
  name: "car-measure-form",
  components: {
    formGroupImage
  },

  props: {
    data: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false
    },
    event: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: NAMES.fullUrl
    }
  },

  computed: {
    ...mapState({
      categoryList: ({
        category
      }) => category.list.map((obj) => {
        return {
          name: obj.name,
          value: obj.id
        }
      }),

      measureList: ({
        measure
      }) => measure.list.map((obj) => {
        return {
          name: obj.name,
          value: obj.id
        }
      }),


    })
  },

  methods: {
    ...mapActions(["getCategoryList", "getMeasureList"]),
    ...mapGetters({
      sidebarFlag: 'sidebarFlag'
    }),
    unlock() {
      if (this.sidebarFlag() === 'ADMIN') {
        this.localReadonly = !this.localReadonly
      } else {
        this.localReadonly = true;
      }
    },

    formatDate(date) {
      return moment.utc(date).utcOffset(-180).format('D/M/YYYY H:mm:ss')
    },

    format: function (sValue) {
      this.data.formattedMarkValueCentavos = parseInt(("" + sValue).onlyNumber()).int2Money();

      this.data.markValueCentavos = this.data.formattedMarkValueCentavos
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {
      });

    },
  },

  created() {
    this.$on("execute", () => {
      this.$parent.$emit(this.event, this.data);
    });

    this.getCategoryList().then(res => {
      this.getMeasureList()
    })

  },
  data() {
    return {
      localReadonly: false,
      isShafts: [
        {
          value: true,
          name: "Sim"
        },
        {
          value: false,
          name: "Não"
        }
      ],
      isCeilingList: [
        {
          value: 1,
          name: "Sim"
        },
        {
          value: 0,
          name: "Não"
        }
      ],
    };
  },

};
</script>
<style scoped lang="scss">
label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/CarMeasureForm.vue